import * as React from 'react';

export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
        <g fill="#000" fillRule="nonzero">
            <path
                d="M7 0C3.14 0 0 3.14 0 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 13.082A6.089 6.089 0 0 1 .918 7
                    6.089 6.089 0 0 1 7 .918 6.089 6.089 0 0 1 13.082 7 6.089 6.089 0 0 1 7 13.082z"
            />
            <path
                d="M7 3.198a2.235 2.235 0 0 0-2.233 2.233.459.459 0 1 0 .918 0 1.316 1.316 0 0 1 2.63 0c0
                    .725-.59 1.315-1.315 1.315a.459.459 0 0 0-.46.459v1.599a.459.459 0 1 0 .919 0V7.616a2.236 2.236 0 0 0
                    1.774-2.185A2.235 2.235 0 0 0 7 3.198zM7 9.58a.576.576 0 1 0 0 1.154.576.576 0 0 0 0-1.153z"
            />
        </g>
    </svg>
);
